import * as React from 'react';
const SvgSync = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={17}
    fill="none"
    viewBox="0 0 14 17"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.44 2.5H2.25A2.25 2.25 0 0 0 0 4.75v5a.75.75 0 0 0 1.5 0v-5A.75.75 0 0 1 2.25 4h9.19l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06zM2.72 16.78a.75.75 0 0 0 1.06-1.06L2.56 14.5h9.19A2.25 2.25 0 0 0 14 12.25v-5a.75.75 0 0 0-1.5 0v5a.75.75 0 0 1-.75.75H2.56l1.22-1.22a.75.75 0 1 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSync;
